import { render, staticRenderFns } from "./biddingHall.vue?vue&type=template&id=88c1fc8a&"
import script from "./biddingHall.vue?vue&type=script&lang=js&"
export * from "./biddingHall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports